import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Carousel } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import {
  addWishlist,
  UserWishlist,
} from "../../../utility/apiServices/userServices";
import LoaderHome from "../../../components/loader/homeloader";
import { description, formatRating, getPriceBasedOnDay } from "../../../utility/local/functions/crypto";
import { useTranslation } from "react-i18next";
const MAX_VISIBLE_IMAGES = 5

const WishlistScreen = () => {
  const navigate = useNavigate();
  const {t , i18n} = useTranslation();
  const [listingsData, setlistingsData] = useState([]);
  const [dataIsLoading, setdataIsLoading] = useState(true);
  const [isloadMoreData, setisloadMoreData] = useState(false);
  const [heartSelect, setHeartSelect] = useState({});
  const [page, setpage] = useState(1);
  const [totalPage, settotalPage] = useState(0);
  const getproperties = async (page) => {
    const response = await UserWishlist(page);
    if (response?.status) {
      setlistingsData([...listingsData, ...response?.wishlist]);
      settotalPage(response.totalPages);
    } else {
    }
    setdataIsLoading(false);
    setisloadMoreData(false);
  };
  useEffect(() => {
    getproperties(page);
  }, []);

  const loadMoreData = async () => {
    setisloadMoreData(true);
    await getproperties(page + 1);
    setpage(page + 1);
  };

  const removeFromWishlist = async (propertyId) => {
    if (!propertyId) return;

    let response = await addWishlist({ propertyId });
    if (response?.status) {
      if (response?.isRemoved) {
        // Remove the objetc
        let RemovedFromWishlist = listingsData.filter(
          (property) => property?.property_id !== propertyId
        );
        setlistingsData(RemovedFromWishlist);
      } else if (response?.isAdded) {
      }
    } else {
      // Handle error case
    }
  };

  const currentLanguage = i18n.language; 

  return (
    <React.Fragment>
      <section className="commonpad">
        <Container fluid>
          <Row className="mb-4">
            <Col md={12}>
              <div className="proFlex">
                <h2>{t("wishlist")}</h2>
              </div>
            </Col>
          </Row>
          <Row>
            {dataIsLoading ? (
              <>
                <div className="text-center d-flex justify-content-center">
                  <LoaderHome />
                </div>
              </>
            ) : (
              <>
                {listingsData?.length ? (
                  listingsData?.map((listing) => (
                    <Col key={listing?.Property?.id} xl={3} md={6}>
                      <div className="listing">
                        <div className="listImgBox">
                          <div className="starRating">
                            <Icon icon="ph:star-fill" />
                            {formatRating(listing?.Property?.averageRating) || 0}
                          </div>
                          <div
                            className="heartBox"
                            onClick={() =>
                              removeFromWishlist(listing?.Property?.id)
                            }
                          >
                            {heartSelect[listing?.Property?.id] ? (
                              <Icon icon="ph:heart-light" />
                            ) : (
                              <Icon icon="ph:heart-fill" color="#ffffff" />
                            )}
                          </div>
                        </div>
                        <Carousel data-bs-theme="dark">
                          {listing?.Property?.images[0].room1?.map((image, index) => (
                            <Carousel.Item key={index}>
                              <div
                                className="listImage"
                                style={{ backgroundImage: `url(${image})` }}
                              ></div>
                            </Carousel.Item>
                          ))}
                        </Carousel>
                        <div className="listing_body">
                          <div className="listing_body_pad">
                            <h2>
                              {" "}
                                {description(listing?.Property?.short_description ,listing?.Property?.short_description_hebrew , currentLanguage)}
                            </h2>
                            <h3>
                              <Icon icon="system-uicons:location" />{" "}
                              {`${
                                listing?.Property?.street_address?.length > 30
                                  ? listing?.Property?.street_address?.slice(
                                      0,
                                      30
                                    ) + "..."
                                  : listing?.Property?.street_address
                              }`}
                            </h3>
                            <div className="listing_iconFlex" style={{ flex: 'flex', flexWrap: 'wrap', margin: '1px 1px 0px 0px' }}>
                                {listing?.Property?.facilities?.map((val, index) => (
                                      <>
                                        {index < MAX_VISIBLE_IMAGES && (
                                          <img
                                            key={index}
                                            className="cardIconImages"
                                            src={val?.imageUrl}
                                            width={25}
                                            height={25}
                                            style={{ borderRadius: '1px solid white' }}
                                          />
                                        )}
                                      </>
                                    ))}

                                    {listing?.Property?.facilities?.length > MAX_VISIBLE_IMAGES && (
                                      <span className="moreText">
                                        +{listing?.Property?.facilities?.length - MAX_VISIBLE_IMAGES}
                                      </span>
                                    )}
                            </div>
                          </div>
                          <div className="listing_body_pad listing_body_footer">
                            <h5>${getPriceBasedOnDay(listing?.Property?.weekdays_discounted_price ,listing?.Property?.weekend_discounted_price) }</h5>
                            <Button
                              onClick={() => {
                                navigate("/property-detail", {
                                  state: {
                                    data: {...listing?.Property ,...{phone_number : listing?.Property?.userDetail?.phone_number , email:listing?.Property?.userDetail?.email}},
                                  },
                                });
                              }}
                              variant="outline-primary"
                            >
                              {t("home.showMore")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))
                ) : (
                  <div className="text-center">
                    {t("yourWishListEmpty")}
                  </div>
                )}
              </>
            )}
          </Row>

          <div className="d-flex align-items-center justify-content-center mt-3">
            {totalPage > page && (
              <Button
                onClick={() => {
                  loadMoreData();
                }}
                variant="primary"
                className="px-5"
              >
                {isloadMoreData ? (
                  <span className="spinner-light"></span>
                ) : (
                  t("viewMore")
                )}
              </Button>
            )}
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default WishlistScreen;
